import { cva } from 'class-variance-authority'

export const inputVariants = cva('focus:ring-primary placeholder:font-normal', {
  variants: {
    variant: {
      text: 'ck w-full rounded-md border border-gray-200 py-1.5 text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6',
      number:
        'block w-full rounded-md border-0 py-1.5 text-gray-900  ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6 pl-6',
      checkbox: 'h-4 w-4 rounded border-gray-300 text-primary',
    },
  },
  defaultVariants: {
    variant: 'text',
  },
})
